export default {"src":"/_next/static/media/clock-icon.ebcc05eb.svg","height":14,"width":14,"blurWidth":0,"blurHeight":0};